import { productPurchasesPath } from "@travily/routes";
import type ListingsPurchasesNew from "@travily/types/pages/ListingsPurchasesNew";
import type { ReactNode } from "react";
import { GuestPurchaseFlow } from "@/components/GuestPurchaseFlow";
import { ProductPurchaseNewView } from "./new.view";

const ProductPurchaseNewPage = ({ listing_sqid, free, success }: ListingsPurchasesNew) => (
  <ProductPurchaseNewView>
    <GuestPurchaseFlow free={free} kind="product" path={productPurchasesPath(listing_sqid)} success={success} />
  </ProductPurchaseNewView>
);

ProductPurchaseNewPage.layout = (page: ReactNode) => page;

export default ProductPurchaseNewPage;
